import { DateTime, Duration, DurationObject } from 'luxon';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

export function dateToday(offset: Duration | DurationObject = {}): NgbDateStruct {
    const { year, month, day } = DateTime.local().plus(offset).toObject();
    return { year, month, day };
}
